import { axios } from '@Root/API'

export const rollback = ids => {
	return axios.post('import/programs/rollback', ids)
}
